import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import { useEffect, useRef, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import {
  useRecognizeCedulaMutation,
  useRecognizeIneMutation,
  useRecognizePassportMutation,
} from '../../services/ocrApi';
import { cleanBase64, getBithdateByStringDate, getYearsBirthByArrivalDate, verifyGuestTypeByAge } from '../../utils';
import { setErrorMajestic, setErrorMessage, setIsLoading, setShowAllowFormats } from '../../app/store/majesticSlice';
import { setDataOCR, setErrorOcr, setImageSide, setIntentsSearchSign } from '../../app/store/ocrSlice';
import usePageNavigation from '../../hooks/usePageNavigation';
import ErrorMessageOcrModal from '../../ui/Modals/ErrorMessageOcrModal';
import InputFile from './components/InputFile';
import useVerifyGuestType from '../../hooks/useVerifyGuestType';
import CustomErrorModal from '../../ui/Modals/CustomErrorModal';
import RecomendationPhotosModal from '../../ui/Modals/RecomendationPhotosModal';

function GuestDocumentPreviewPage() {
  const {
    documentType,
    imageSide,
    imageFront,
    imageReverse,
    wayCaptureDocument,
    fileType,
    intentsSearchSign,
  } = useSelector((state) => state.ocr);
  // const inputFileRef = useRef();
  const [existSignature, setExistSignature] = useState(true);
  const [existError, setExistError] = useState(false);
  const [showRecomendationModal, setShowRecomendationModal] = useState(false);
  const [
    recognizeIne,
    {
      data: dataINE,
      isError,
      isSuccess,
    }] = useRecognizeIneMutation();
  const [
    recognizePassport,
    {
      isError: isErrorPassport,
    }] = useRecognizePassportMutation();
  const [
    recognizeCedula,
    {
      isError: isErrorCedula,
    }] = useRecognizeCedulaMutation();
  // const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { booking } = useSelector((state) => state.booking);

  const { navigateNextPage } = usePageNavigation();
  const { verifyGuestType } = useVerifyGuestType();

  const methods = useForm({
    defaultValues: {
      documentType,
    },
  });

  useEffect(() => {
    console.log("MOntado")
    return () => {
      dispatch(setIsLoading(false));
    };
  }, [dispatch]);

  // console.log(JSON.stringify(error))
  // useEffect(() => {
  //   if (isSuccess) {
  //     console.log(dataINE);
  //   }

  //   return () => {
  //     dispatch(setIsLoading(false));
  //     dispatch(setShowAllowFormats({ show: false }));
  //   };
  // }, [dispatch, isSuccess, dataINE]);

  const handleAgainCapture = () => {
    if (wayCaptureDocument === 'byFile') {
      if (imageSide === 'imageFront') {
        navigateNextPage('DocumentFront');
      } else {
        navigateNextPage('DocumentReverse');
      }
    }
    if (wayCaptureDocument === 'byScanner') {
      if (imageSide === 'imageFront') {
        navigateNextPage('DocumentFrontCapture');
      } else {
        navigateNextPage('DocumentReverseCapture');
      }
    }
  };

  const handlerNoMatchGuest = (verifyGuest) => {
    const message = t(
      'TXT_WARNING_NO_MACTH_GUEST_TYPE',
      {
        typeDocument: t(`TXT_${documentType}`).toLowerCase(),
        guestBirthday: `${parseInt(verifyGuest.selectedGuest.Edad, 10)}-${verifyGuest.initGuestType.tagkey}`,
      },
    );
    dispatch(setIsLoading(false));
    dispatch(setErrorMajestic({ message }));
    setExistError(true);
  };

  const handlerRecognizePassport = async (base64 = '') => {
    dispatch(setIsLoading(true));

    const { data } = await recognizePassport({
      imageFront: cleanBase64(imageFront),
      imageBack: cleanBase64(base64),
      numberReservation: booking.NumReserva,
      documentType: fileType,
    }).unwrap();

    // if (!data.front.signature && intentsSearchSign < 1) {
    if (!data.front.signature && base64 === '') {
      dispatch(setIsLoading(false));
      setExistSignature(false);
      dispatch(setErrorOcr({ messageFormatted: t('TXT_NOT_FOUND_SIGN_ON_IMAGE') }));
      return;
    }

    const verifyGuest = verifyGuestType(data?.front?.birthDate || null);

    if (!verifyGuest.isMatchGuest) {
      handlerNoMatchGuest(verifyGuest);
      return; // Stop propagation
    }

    dispatch(setDataOCR(data));
    navigateNextPage('DocumentationReview');
  };

  const handlerRecognizeIne = async (base64 = '') => {
    dispatch(setIsLoading(true));

    const { data } = await recognizeIne({
      imageFront: cleanBase64(imageFront),
      imageBack: cleanBase64(base64),
      numberReservation: booking.NumReserva,
      documentType: fileType,
    }).unwrap();

    const verifyGuest = verifyGuestType(data?.front?.birthDate || null);

    if (!verifyGuest.isMatchGuest) {
      handlerNoMatchGuest(verifyGuest);
      return; // Stop propagation
    }

    dispatch(setDataOCR(data));
    navigateNextPage('DocumentationReview');
  };

  const handlerRecognizeCedula = async (base64) => {
    dispatch(setIsLoading(true));

    const { data } = await recognizeCedula({
      imageFront: cleanBase64(imageFront),
      imageBack: cleanBase64(base64),
      numberReservation: booking.NumReserva,
      documentType: fileType,
    }).unwrap();

    const verifyGuest = verifyGuestType(data?.front?.birthDate || null);

    if (!verifyGuest.isMatchGuest) {
      handlerNoMatchGuest(verifyGuest);
      return; // Stop propagation
    }

    dispatch(setDataOCR(data));
    navigateNextPage('DocumentationReview');
  };

  const handleShowRecomendationModal = () => {
    setShowRecomendationModal(true);
  };

  const handleConfirmRecomendationPhoto = () => {
    navigateNextPage('DocumentReverseCapture');
  };

  const onSubmit = async () => {
    // console.log(wayCaptureDocument);

    if (wayCaptureDocument === 'byFile') {
      if (documentType === 'PASSPORT') {
        if (intentsSearchSign === 1) {
          dispatch(setShowAllowFormats({ show: true }));
          return;
        }
        if (imageFront !== '' && imageReverse !== '') {
          handlerRecognizePassport(imageReverse);
        } else {
          handlerRecognizePassport();
        }
        return;
      }

      if (documentType === 'INE') {
        if (imageReverse === '') {
          dispatch(setShowAllowFormats({ show: true }));
        }
        if (imageFront !== '' && imageReverse !== '') {
          handlerRecognizeIne(imageReverse);
        }
        return;
      }

      if (documentType === 'CEDULA') {
        if (imageReverse === '') {
          dispatch(setShowAllowFormats({ show: true }));
        }
        if (imageFront !== '' && imageReverse !== '') {
          handlerRecognizeCedula(imageReverse);
        }
      }
    }
    if (wayCaptureDocument === 'byScanner') {
      if (documentType === 'PASSPORT') {
        // if (intentsSearchSign === 1) {
        //   dispatch(setShowAllowFormats({ show: true }));
        //   return;
        // }
        if (imageFront !== '' && imageReverse !== '') {
          handlerRecognizePassport(imageReverse);
        } else {
          handlerRecognizePassport();
        }
        return;
      }

      if (documentType === 'INE') {
        if (imageFront !== '' && imageReverse !== '') {
          handlerRecognizeIne(imageReverse);
          return;
        }
      }

      if (documentType === 'CEDULA') {
        if (imageFront !== '' && imageReverse !== '') {
          handlerRecognizeCedula(imageReverse);
          return;
        }
      }

      if (imageReverse === '') {
        handleShowRecomendationModal()
        // navigateNextPage('DocumentReverseCapture');
      }
    }
  };

  const handleGetSignPassport = () => {
    setExistSignature(true);
    dispatch(setIntentsSearchSign(intentsSearchSign + 1));

    if (wayCaptureDocument === 'byFile') {
      dispatch(setShowAllowFormats({ show: true }));
    } else {
      navigateNextPage('DocumentReverseCapture');
    }
  };

  const handleFileLoaded = (data) => {
    const { documentSide, fileType: newFileType, imageData } = data;

    // console.log(documentSide, fileType, documentType)
    dispatch(setImageSide({ imageSide: documentSide, imageData, newFileType }));
    if (documentType === 'PASSPORT') {
      handlerRecognizePassport(imageData, 'imageReverse', newFileType);
    }

    if (documentType === 'INE') {
      handlerRecognizeIne(imageData, 'imageReverse', newFileType);
    }

    if (documentType === 'CEDULA') {
      handlerRecognizeCedula(imageData, 'imageReverse', newFileType);
    }
  };

  const handleChangeErrorExist = () => {
    setExistError(false);
  };

  return (
    <div className="guest__document-preview d-flex flex-column h-100">
      <div className="text-center">
        <p className="mb-0 app-txt-granite pp-fw-figtree-regular">{t('TXT_TITLE_CHECK_IN')}</p>

        <p className="my-3 app-fs-h4 app-lh-h4 app-txt-granite app-fw-notosans-bold">
          {t(`TXT_${imageSide === 'imageFront' ? 'FRONT' : 'REVERSE'}_DOCUMENT`)}
          {' '}
          {t(`TXT_${documentType}`)}
        </p>

        <p className="mb-3 app-txt-granite-80-dark">{t('TXT_CHECK_PHOTO')}</p>
      </div>

      <FormProvider
        control={methods.control}
        handleSubmit={methods.handleSubmit}
        setValue={methods.setValue}
        getValues={methods.getValues}
        watch={methods.watch}
        formState={methods.formState}
        register={methods.register}
        trigger={methods.trigger}
      >
        <Card className="border-solid-1 app-border-granite-80-light mb-3">
          <Card.Body className="scd">
            <div className="text-center">
              <div className="dp__image mx-auto">
                <img
                  style={{
                    height: '225px',
                    maxWidth: '100%',
                  }}
                  src={imageSide === 'imageFront' ? imageFront : imageReverse}
                  alt={imageSide}
                />
              </div>
            </div>
          </Card.Body>
          <div className="text-center">
            <Button
              onClick={handleAgainCapture}
              variant="link"
              type="button"
              className="bg-transparent app-fw-notosans-bold app-txt-gold w-100 rounded-3 btn-height border-0 mt-2 px-0"
            >
              {t('TXT_RECAPTURE')}
            </Button>
          </div>
        </Card>

        <InputFile
          // ref={inputFileRef}
          handlerPassport={handlerRecognizePassport}
          handlerIne={handlerRecognizeIne}
          handlerCedula={handlerRecognizeCedula}
          onFileLoaded={(data) => handleFileLoaded(data)}
        />

        <div className="d-flex flex-grow-1 align-items-end pb-2">
          <Button
            //disabled={!allowContinue()}
            onClick={(event) => onSubmit(event)}
            variant=""
            type="button"
            className="app-bg-sand app-fw-notosans-bold app-txt-granite w-100 rounded-3 btn-height border-0"
          >
            {t('TXT_BOTON_CONTINUE')}
          </Button>
        </div>
      </FormProvider>
      {existError && <CustomErrorModal handleCloseModal={handleChangeErrorExist} />}
      {isError && <ErrorMessageOcrModal />}
      {isErrorCedula && <ErrorMessageOcrModal />}
      {isErrorPassport && <ErrorMessageOcrModal />}
      {!existSignature && <ErrorMessageOcrModal handleCloseModal={handleGetSignPassport} />}
      {showRecomendationModal && (
        <RecomendationPhotosModal
          showModal
          handleConfirmAttachment={handleConfirmRecomendationPhoto}
          handleHideFormatsModal={() => setShowRecomendationModal(false)}
        />
      )}
    </div>
  );
}

export default GuestDocumentPreviewPage;
